import React from 'react';
import SEO from '../components/SEO';
import { useWebsiteContent } from '../hooks/useWebsiteContent';
import './About.css';

const About = () => {
  const { content, loading } = useWebsiteContent('about');

  if (loading) {
    return <div style={{ padding: '2rem', textAlign: 'center' }}>Loading...</div>;
  }

  return (
    <div className="about">
      <SEO
        title="About MarketVendr - UK Import & Distribution Experts"
        description="Learn about MarketVendr's mission to help international businesses import products to the UK legally and safely. We provide comprehensive UK distribution, customs clearance, and warehousing services from our UK warehouse."
        keywords="about MarketVendr, UK import company, UK distribution experts, UK customs clearance specialists, UK import services, UK warehousing, alcohol import UK, UK import compliance"
        url="https://www.marketvendr.com/about"
        structuredData={{
          "@context": "https://schema.org",
          "@type": "AboutPage",
          "mainEntity": {
            "@type": "Organization",
            "name": "MarketVendr",
            "description": "UK import and distribution services for international businesses"
          }
        }}
      />
      <section className="about-hero">
        <div className="container">
          <h1>{content.about_title || 'About MarketVendr'}</h1>
          <p className="about-intro">
            {content.about_intro || 'We are a leading provider of logistics, distribution, and customs clearance services, dedicated to helping businesses navigate the complexities of global trade.'}
          </p>
        </div>
      </section>

      <section className="about-content">
        <div className="container">
          <div className="about-section">
            <h2>{content.mission_title || 'Our Mission'}</h2>
            <p>
              {content.mission_para1 || 'At MarketVendr, we are dedicated to simplifying and accelerating UK market entry for global brands by delivering a direct, reliable, and expertly managed route to market. We are committed to removing the traditional barriers of UK distribution by offering streamlined access to both D2C marketplaces and B2B wholesale channels, supported by transparent operations and a proven track record of success.'}
            </p>
            <p>
              {content.mission_para2 || 'We exist to give brands the confidence to scale, providing comprehensive support across every stage of the journey—from navigating complex UK labelling and regulatory requirements to managing inbound transport, warehousing, and final-mile delivery. With our experienced compliance team, trusted customs partners, and secure logistics infrastructure, we ensure products reach the UK efficiently, legally, and ready for sale.'}
            </p>
          </div>

          <div className="about-section">
            <h2>{content.vision_title || 'Our Vision'}</h2>
            <p>
              {content.vision_para || 'Our purpose is to act as an extension of each brand we serve: a partner dedicated to operational excellence, inventory visibility, and dependable fulfilment. By taking ownership of the operational and regulatory complexities, we empower our partners to focus solely on building their UK sales strategy, expanding their market presence, and realising sustained, long-term growth.'}
            </p>
          </div>

          <div className="about-section">
            <h2>{content.why_title || 'Why Choose Us'}</h2>
            <div className="features-grid">
              <div className="feature">
                <h3>{content.about_expert_title || 'Expert Team'}</h3>
                <p>{content.about_expert_desc || 'Our experienced professionals understand the nuances of international trade and logistics.'}</p>
              </div>
              <div className="feature">
                <h3>{content.about_network_title || 'Global Network'}</h3>
                <p>{content.about_network_desc || 'Extensive network of partners and facilities across key markets worldwide.'}</p>
              </div>
              <div className="feature">
                <h3>{content.about_tech_title || 'Technology-Driven'}</h3>
                <p>{content.about_tech_desc || 'Advanced systems and tools to track, manage, and optimize your supply chain.'}</p>
              </div>
              <div className="feature">
                <h3>{content.about_customer_title || 'Customer-Focused'}</h3>
                <p>{content.about_customer_desc || 'Dedicated support team committed to your success and satisfaction.'}</p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default About;

